import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cls from 'classnames';
import './style.scss';

interface IPrivacyUserContent {
  className?: string;
}

const UserPrivacyContent: FC<IPrivacyUserContent> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  return (
    <div className={cls('privacy-user-content', className)}>
      <div className="privacy-user-content-illustration" />
      <div className="privacy-user-content-desc">
        <div>{t('privateAccount_profile_header')}</div>
        <div>{t('privateAccount_profile_body')}</div>
      </div>
    </div>
  );
};

export default UserPrivacyContent;
